import { SVGProps, Ref, forwardRef } from 'react';

export const ExclamationCircleOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.789 5.59C3.424 7.228 2.8 9.517 2.8 12s.624 4.772 1.989 6.41C6.106 19.99 8.308 21.2 12 21.2s5.894-1.21 7.211-2.79C20.576 16.772 21.2 14.483 21.2 12s-.624-4.772-1.989-6.41C17.894 4.01 15.692 2.8 12 2.8S6.106 4.01 4.789 5.59M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m-.9 12.5V6h1.8v7.5zM12 15a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ExclamationCircleOutlinedSize24Glyph.displayName = 'ExclamationCircleOutlinedSize24Glyph';
